module.exports = __webpack_public_path__ + "img/6ne.ecbd1906.svg";